module.exports = __webpack_public_path__ + "img/undTooth11.018334d9.png";